import { render } from "./AgenciesSettings.vue?vue&type=template&id=2acef407&scoped=true"
import script from "./AgenciesSettings.vue?vue&type=script&lang=js"
export * from "./AgenciesSettings.vue?vue&type=script&lang=js"

import "./AgenciesSettings.vue?vue&type=style&index=0&id=2acef407&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acef407"]])

export default __exports__